import { createAnalyticsCategories } from '@analytics/utils';
import { Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { OrderEntry } from '@spartacus/core';
import { AnalyticsService } from './analytics.service';
import { ProductListCartAnalyticsService } from './product-list/product-list-cart-analytics.service';

@Injectable({ providedIn: 'root' })
export class CartAnalyticsService {
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly productListCartAnalyticsService: ProductListCartAnalyticsService,
  ) {}

  onAddToCart(entry: OrderEntry): void {
    const listName = this.productListCartAnalyticsService.getListNameByEntry(entry);
    const index = this.productListCartAnalyticsService.getProductIndexByEntry(entry);
    const product = entry.product as CustomProduct;
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product?.categoryNamesForAnalytics)
      : {};

    this.analyticsService.sendEcommerceEvent({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_name: entry.product.name,
            item_id: entry.product.code,
            item_list_name: listName,
            price: entry.basePrice.value,
            quantity: entry.quantity,
            index: typeof index === 'number' ? index + 1 : undefined,
            ...categoryNamesForAnalytics,
          },
        ],
      },
    });
  }

  onRemoveFromCart(entry: OrderEntry): void {
    const listName = this.productListCartAnalyticsService.getListNameByEntry(entry);
    const index = this.productListCartAnalyticsService.getProductIndexByEntry(entry);
    const product = entry.product as CustomProduct;
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product?.categoryNamesForAnalytics)
      : {};

    this.analyticsService.sendEcommerceEvent({
      event: 'remove_from_cart',
      ecommerce: {
        items: [
          {
            item_name: entry.product.name,
            item_id: entry.product.code,
            item_list_name: listName,
            price: entry.basePrice.value,
            quantity: entry.quantity,
            index: typeof index === 'number' ? index + 1 : undefined,
            ...categoryNamesForAnalytics,
          },
        ],
      },
    });
  }
}
